import axios from 'axios'
import { useQuery } from 'react-query'

import { Student } from 'types/student.types'
import { TA_DRAFT_SHEET_API_PATH } from 'config/app.config'
import { getDraftBaseUrl } from 'utils/draftBase'

// Function to fetch students data
const fetchSignUps = async (): Promise<Student[]> => {
  const url = `${await getDraftBaseUrl()}${TA_DRAFT_SHEET_API_PATH}`

  let response
  try {
    response = await axios.get(url)
  } catch (error) {
    console.trace(error)
    throw new Error('Network response was not ok')
  }

  // Validate data
  const data = response.data
  const list = data['data']
  if (!Array.isArray(list)) {
    throw new Error('Data is not an array')
  }

  return list as Student[]
}

// Custom hook using react-query
export const useSignUps = () => {
  return useQuery<Student[], Error>('signups', fetchSignUps)
}
